import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { inject, observer } from 'mobx-react'

import CloseModalIcon from '../../images/icons/close-modal.svg'

@inject('modalStore')
@observer
class Modal extends Component {

  constructor(props) {
    super(props)
  }

  close = () => {
    this.props.modalStore.setState(this.props.slug, false)
  }

  render() {

    const { open } = this.props.modalStore.states[this.props.slug]

    return (
      <ModalWrapper open={ open } onClick={ !this.props.unclosable && this.close }>
        <ModalBox
          onClick={ e => e.stopPropagation() }
          open={ open }
        >
          { !this.props.unclosable && <ModalNavigation>
            <CloseModal src={ CloseModalIcon } onClick={ this.close }/>
          </ModalNavigation> }
          { this.props.children }
        </ModalBox>
      </ModalWrapper>
    )
  }
}

export default Modal

const ModalWrapper = styled.div `
  top: 0; right: 0; bottom: 0; left: 0;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: fixed;
  z-index: 999;
  transition: all ${ cssVar.transitions.basic };
  background: ${ props => props.open ? '#00000066' : '#00000000'};
  pointer-events: ${ props => props.open ? 'all' : 'none'};
`

const ModalBox = styled.div `
  position: absolute;
  background: white;
  width: ${ cssVar.max_content_width / 2 }px;
  max-width: calc( 100vw - 100px );
  max-height: calc( 100vh - 120px );
  height: auto;
  overflow-y: auto;

  top: ${ props => props.open ? '50%' : '100%'};
  left: 50%;
  transition: all ${ cssVar.transitions.basic };
  transform: ${ props => props.open ? 'translate(-50%, -50%)' : 'translate(-50%, 100%)'};
  opacity: ${ props => props.open ? '1' : '0.3'};

  pointer-events: all;

  padding: 50px;
  color: black;

  ${cssVar.breakpoints.phone} {
    max-width: calc( 100vw - 60px );
    max-height: calc( 100vh - 60px );
    padding: 30px;
  }
`

const ModalNavigation = styled.div `
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 50px;

  ${cssVar.breakpoints.phone} {
  margin-bottom: 30px;
  }
`

const CloseModal = styled.img `
  width: 30px;
  height: 30px;
  object-fit: contain;
  transition: all ${ cssVar.transitions.basic };
  cursor: pointer;

  :hover {
    transform: rotate(-15deg) scale(1.1);
  }
`



// WEBPACK FOOTER //
// /src/components/marketing/Modal.js